:host {
}

.container {
  position: relative;
}

.page-blocker__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(4px);
    z-index: 999;
    border-radius: var(--border-small);
}

.page-blocker__container {
    padding: var(--spacing-medium);
    background: var(--color-foreground);
    border-radius: var(--border-small);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: var(--shadow-small);
    box-sizing: border-box;
    display: grid;
    gap: var(--spacing-small);
}

.page-blocker__logo {
    width: 50px;
    height: 50px;
    background-color: var(--color-brand-primary);
}

.page-blocker__message {
}

.page-blocker__button {
    background-color: var(--color-info);
    padding: var(--spacing-small) var(--spacing-medium);
    border-radius: var(--border-small);
    margin: auto;
    color: var(--color-foreground);
    text-decoration: none;
}

.page-blocker__button:hover {
    background-color: var(--color-info-light);
}

.page-blocker__button:active {
    background-color: var(--color-info);
    opacity: 0.8;
    transform: scale(0.95);
}

@media (max-width: 756px) {
    .page-blocker__container {
        width: 90%;
    }
}
